module.exports = __webpack_public_path__ + "img/default.5173cfb9.svg";